import { render, staticRenderFns } from "./ModelAudit.vue?vue&type=template&id=55f71303&scoped=true"
import script from "./ModelAudit.vue?vue&type=script&lang=js"
export * from "./ModelAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f71303",
  null
  
)

export default component.exports